console.log("test from dev1");


let documentationType = document.getElementsByClassName('documentation-type');

for (let i = 0; i < documentationType.length; i++){
  documentationType[i].addEventListener('click', handleClick(documentationType[i]));

}

function handleClick(type) {
  if(document.getElementById('doc-item-view')) {
    document.getElementById('doc-item-view').style.display = 'block';
  }

}
